import { DrawerType } from '../DrawerState';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useOpenDrawer = () => {
  const { state, dispatch } = useCampaignEditorContext();

  return (id: string, type: DrawerType) => {
    if (state.drawer.open) {
      dispatch({
        type: 'CLOSE',
      });

      setTimeout(() => {
        dispatch({
          type: 'OPEN',
          payload: {
            id,
            type,
          },
        });
      }, 0);
    } else {
      dispatch({
        type: 'OPEN',
        payload: {
          id,
          type,
        },
      });
    }
  };
};
